import React, { useState, createContext, useContext } from "react";
import styles from "./styles.module.css";

const TabContext = createContext();

export function Tabs({ defaultValue, value, onValueChange, children }) {
  const isControlled = value !== undefined;
  const [internalValue, setInternalValue] = useState(defaultValue);
  const activeTab = isControlled ? value : internalValue;

  const setActiveTab = (nextValue) => {
    if (!isControlled) {
      setInternalValue(nextValue);
    }
    if (onValueChange) {
      onValueChange(nextValue);
    }
  };

  return (
    <TabContext.Provider value={{ activeTab, setActiveTab }}>
      <main className={styles.tab_container}>{children}</main>
    </TabContext.Provider>
  );
}

export function TabList({ children, className }) {
  return <section className={`${styles.tab_list} ${className || ""}`}>{children}</section>;
}

export function TabTrigger({
  value,
  children,
  handleClick,
  className,
  activeClassName,
}) {
  const { activeTab, setActiveTab } = useContext(TabContext);
  const isActive = activeTab === value;

  return (
    <button
      data-selected={isActive}
      className={`${styles.tab_trigger} ${className || ""} ${
        isActive ? `${styles.tab_trigger_active} ${activeClassName || ""}` : ""
      }`}
      onClick={() => {
        setActiveTab(value);
        if (handleClick) handleClick();
      }}
    >
      {children}
    </button>
  );
}

export function TabPanels({ children, className }) {
  return <section className={`${styles.tab_panels_container} ${className || ""}`}>{children}</section>;
}

export function Panel({ value, children }) {
  const { activeTab } = useContext(TabContext);
  if (activeTab !== value) return null;
  return <section className={styles.tab_panel}>{children}</section>;
}
